import { CustomConnectionForm } from "src/customConnectionNode/types";

export const isBodyEmpty = (
  body: CustomConnectionForm["body"],
  verb: CustomConnectionForm["verb"],
) => {
  if (verb === "get" || verb === "head" || verb === "options") {
    return true;
  }

  const { value } = body;
  switch (value.selected) {
    case "key_values":
      return value.key_values.length === 0;
    case "raw":
      return value.raw === "";
    case "jinja_template":
      return value.template === "";
  }
};
